var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPencilSolid = function SvgPencilSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 3.922c-.95 0-1.86.377-2.53 1.048l-.502.501.032.03 5 4.999.03.031.5-.5a3.578 3.578 0 0 0-2.53-6.11Zm.97 7.668a.792.792 0 0 1-.03-.03l-5-4.998a.774.774 0 0 1-.03-.032l-8.94 8.94a.75.75 0 0 0-.22.53v4c0 .415.336.75.75.75h4a.75.75 0 0 0 .53-.22l8.94-8.94Z",
    fill: "currentColor"
  })));
};
export default SvgPencilSolid;